angular.
module("dx.webapp.api").
factory("dxApiV1Files", function apiV1FilesService() {
	"use strict";

	function uploadUrl() {
		return "api/v1/files";
	}

	return {
		uploadUrl: uploadUrl,
	};
});
